$(function() {
  window.initializeModals();
  window.initializeTooltips();
  window.initCustomFileInput();
});

window.initializeModals = function() {
  $modalsActivators = $('[data-toggle=modal]');
  $modalsActivators.off('click');

  $modalsActivators.click(function(event) {
    $(this.dataset.target).modal('toggle');
  });
}

window.initializeTooltips = function() {
  $("body").tooltip({
    selector: '[data-toggle=tooltip]',
    container: 'body',
  });

  $('[data-toggle=tooltip]').mouseleave(function(evt) {
    let $tooltips = $('.tooltip');
    if ($tooltips) {
      $tooltips.remove();
    }
  });
}

window.resetTooltips = function(parentElement) {
  const tooltipSelector = '[data-toggle="tooltip"]';

  let $tooltips = parentElement
    ? $(tooltipSelector)
    : $(parentElement).find(tooltipSelector);

  $tooltips.off('mouseleave');
  $tooltips.tooltip().tooltip('dispose');

  window.initializeTooltips();
}

window.resetTooltipsAndPopovers = function() {
  window.resetTooltips();

  let $popovers = $('[data-toggle="popover"]');
  $popovers.popover('dispose');
  $popovers.popover();
}

window.initCustomFileInput = function() {
  bsCustomFileInput.init();
}



// WEBPACK FOOTER //
// ./resources/assets/js/commons/init-plugins.js